export class UpdatePassword {
    constructor(
      public confirmationCode: string,
      public password: string
    ) {}
}
